import lazyLoading from './lazyLoading.js'

export default {
  name: 'imports',
  meta: {
    title: 'Imports',
    iconClass: 'vuestic-icon vuestic-icon-tables'
  },
  path: '/imports',
  component: lazyLoading('imports/Imports')
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/imports.js